/**
 * 收件转发 webhook 可用占位符变量（与后端 webhook.rs 的 WebhookVars 保持一致）
 */
export interface WebhookPlaceholder {
  token: string
  label: string
  hint: string
}

export const WEBHOOK_PLACEHOLDERS: WebhookPlaceholder[] = [
  { token: '${domain}', label: '收件域', hint: '收件域名，如 example.com' },
  { token: '${to}', label: '收件人', hint: '收件人地址' },
  { token: '${from}', label: '发件人', hint: '发件人地址' },
  { token: '${subject}', label: '主题', hint: '邮件主题' },
  { token: '${message_id}', label: 'Message-ID', hint: '邮件 Message-ID 头' },
  { token: '${mail_content}', label: '纯文本正文', hint: '邮件纯文本正文' },
  { token: '${raw}', label: '原始邮件 (base64)', hint: '整封原始邮件 base64 编码' },
]